import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
  DialogFooter,
} from "@core/components/ui/dialog";
import { useDialog } from "@core/components/ui/use-dialog";
import { useTranslation } from "react-i18next";

export function DialogProvider() {
  const { dialogs } = useDialog();
  const { t } = useTranslation();

  return (
    <>
      {dialogs.map(function ({
        id,
        title,
        description,
        content,
        action,
        className,
        modal,
        ...props
      }) {
        return (
          <Dialog key={id} open={props.open} onOpenChange={props.onOpenChange} modal={modal}>
            <DialogContent className={className}>
              <DialogHeader>
                {title && <DialogTitle>{title}</DialogTitle>}
                <DialogDescription>
                  {description || title}
                </DialogDescription>
              </DialogHeader>
              {content}
              <DialogFooter>
                {action
                  ? (action)
                  : (
                    <DialogClose>
                      {t("ui.close", "Close")}
                    </DialogClose>
                  )}
              </DialogFooter>
            </DialogContent>
          </Dialog>
        );
      })}
    </>
  );
}
